import { render, staticRenderFns } from "./memu.vue?vue&type=template&id=b720ccb8&scoped=true&"
import script from "./memu.vue?vue&type=script&lang=js&"
export * from "./memu.vue?vue&type=script&lang=js&"
import style0 from "./memu.vue?vue&type=style&index=0&id=b720ccb8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b720ccb8",
  null
  
)

export default component.exports